import { render } from "./BaseEntityLink.vue?vue&type=template&id=494f923d&scoped=true"
import script from "./BaseEntityLink.vue?vue&type=script&lang=js"
export * from "./BaseEntityLink.vue?vue&type=script&lang=js"

import "./BaseEntityLink.vue?vue&type=style&index=0&id=494f923d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494f923d"]])

export default __exports__